import { apiClient, ApiClient } from "@/lib/api/api-client";
import { BusinessBaseInfo } from "@/modules/types/business/business";
import { BaseResponse } from "@/modules/types/response";
import { Industry } from "@/modules/types/metadata/metadata";

interface BusinessResp extends BaseResponse {
  businessInfos?: BusinessBaseInfo[];
  total: number;
  nextId?: string;
}

export interface IndustryResponse extends BaseResponse {
  industry?: Industry[];
}

export class BusinessService {
  private BASE_PATH =
    process.env.API_BUSINESS_ENDPOINT || "http://localhost:8081/business";
  private apiClient: ApiClient = apiClient;
  private apiVersion = "v1.0.0";
  constructor(apiVersion?: string) {
    this.apiVersion = apiVersion || this.apiVersion;
  }

  async getIndustries(): Promise<IndustryResponse> {
    return await this.apiClient.fetch<IndustryResponse>(
      `${this.BASE_PATH}/${this.apiVersion}/industries`,
    );
  }

  async getCompanies({
    search,
    nextId,
    limit,
    offset,
  }: {
    search?: string;
    nextId?: string;
    limit?: number;
    offset?: number;
  }): Promise<BusinessResp | undefined> {
    const queryParam = new URLSearchParams();
    if (search) {
      queryParam.set("businessName", search);
    }
    if (nextId) {
      queryParam.set("nextId", nextId);
    }
    if (limit) {
      queryParam.set("limit", limit.toString());
    }
    if (offset) {
      queryParam.set("offset", offset.toString());
    }
    return this.apiClient.fetch<BusinessResp>(
      `${this.BASE_PATH}/${this.apiVersion}/search?${queryParam.toString()}`,
    );
  }

  async searchCompanies({
    search,
    nextId,
    limit,
    offset,
  }: {
    search?: string;
    nextId?: string;
    limit?: number;
    offset?: number;
  }): Promise<BusinessResp | undefined> {
    const queryParam = new URLSearchParams();
    if (search) {
      queryParam.set("businessName", search);
    }
    if (nextId) {
      queryParam.set("nextId", nextId);
    }
    if (limit) {
      queryParam.set("limit", limit.toString());
    }
    if (offset) {
      queryParam.set("offset", offset.toString());
    }
    return this.apiClient.fetch<BusinessResp>(
      `${this.BASE_PATH}/${this.apiVersion}/search?${queryParam.toString()}`,
    );
  }
}

export const businessService = new BusinessService();
